module.exports = __webpack_public_path__ + "static/media/sleep.f073bf40.jpg";